export const ScrollToFirstError = () => {
  const scrollToFirstError = async (rootEl) => {
    await new Promise(resolve => setTimeout(resolve, 0));
    const el = rootEl?.querySelector('[class*="--has-error"]');
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return { scrollToFirstError };
};
